import type { ILayoutBlockTrailerProps } from './LayoutBlockPoster.h'

import { OverlayLayout, PosterContainer } from 'blocks/Banner/Banner.styled'
import { useClientWidth } from 'utils/hooks'
import { BANNER_ASPECT_RATIO } from 'vars/banner-aspect-ratio'
import { BANNER_WIDTH } from 'vars/banner-width'
import { PosterOverlay, PosterOverlayDirection } from './LayoutBlockPoster.h'
import {
  DetailsBannerTrailerSC,
  LayoutBlockTrailerSC,
} from './LayoutBlockPoster.styled'

/** Matches `MEDIA.MAX_1239`: trailer overlay is vertical through 1239px (FP-4289). */
const COMPACT_TRAILER_MAX_WIDTH = 1239

export const LayoutBlockTrailer = ({
  overlayEnabled = true,
  overlayHeight,
  overlay = PosterOverlay.SURFACE_OPACITY_DARK_40,
  overlayHorizontal = PosterOverlay.BANNER_HORIZONTAL_OVERLAY,
  overlayVertical = PosterOverlay.BANNER_VERTICAL_OVERLAY,
  overlayWidth,
  overlayDirection = PosterOverlayDirection.OVERLAY_VERTICAL,
  posterUrl: _unused1 = '',
  posterMobileUrl: _unused2 = '',
  fallbackImageSize: _unused3,
  width = BANNER_WIDTH.SIZE_100,
  aspectRatio = BANNER_ASPECT_RATIO.SIZE_10,
  children,
  visible = true,
  detailsBanner = false,
  ...rest
}: ILayoutBlockTrailerProps) => {
  const clientWidth = useClientWidth()
  const Root = detailsBanner ? DetailsBannerTrailerSC : LayoutBlockTrailerSC
  const isDetailsTrailerPlaying = detailsBanner && visible
  const isCompactTrailerVisible =
    isDetailsTrailerPlaying &&
    clientWidth > 0 &&
    clientWidth <= COMPACT_TRAILER_MAX_WIDTH

  return (
    <Root
      width={width}
      aspectRatio={aspectRatio}
      visible={visible}
      data-details-trailer-playing={
        isDetailsTrailerPlaying ? 'true' : undefined
      }
      {...rest}
    >
      {detailsBanner ? (
        <PosterContainer isTrailer>{children}</PosterContainer>
      ) : (
        children
      )}
      <OverlayLayout
        overlay={overlay}
        overlayHorizontal={overlayHorizontal}
        overlayVertical={overlayVertical}
        overlayDirection={
          isCompactTrailerVisible
            ? PosterOverlayDirection.OVERLAY_VERTICAL
            : overlayDirection
        }
        overlayEnabled={overlayEnabled}
        overlayWidth={overlayWidth}
        overlayHeight={isCompactTrailerVisible ? 100 : overlayHeight}
      />
    </Root>
  )
}
